import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "objects"
    }}>{`Objects`}</h1>
    <p>{`Root of the API, accessed at `}<inlineCode parentName="p">{`require("photoshop")`}</inlineCode></p>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <h3 {...{
      "id": "action"
    }}>{`action`}</h3>
    <p>{`• `}<strong parentName="p">{`action`}</strong>{`: `}<em parentName="p">{`typeof`}</em>{` `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/media/photoshopaction/"
      }}><em parentName="a">{`photoshopAction`}</em></a></p>
    <p>{`The set of lower level APIs for interfacing with the action system, including `}<inlineCode parentName="p">{`batchPlay`}</inlineCode>{`,
evolution of `}<inlineCode parentName="p">{`executeAction`}</inlineCode></p>
    <hr></hr>
    <h3 {...{
      "id": "app"
    }}>{`app`}</h3>
    <p>{`• `}<strong parentName="p">{`app`}</strong>{`: `}<em parentName="p">{`typeof`}</em>{` `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/photoshop/"
      }}><em parentName="a">{`Photoshop`}</em></a></p>
    <p>{`Root of the DOM, the `}<inlineCode parentName="p">{`app`}</inlineCode>{` object where you can access application settings,
open documents and reach rest of the APIs`}</p>
    <hr></hr>
    <h3 {...{
      "id": "constants"
    }}>{`constants`}</h3>
    <p>{`• `}<strong parentName="p">{`constants`}</strong>{`: `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/modules/constants/"
      }}><em parentName="a">{`Constants`}</em></a></p>
    <p>{`The different constants and enumerations that DOM APIs expect as certain parameters`}</p>
    <hr></hr>
    <h3 {...{
      "id": "core"
    }}>{`core`}</h3>
    <p>{`• `}<strong parentName="p">{`core`}</strong>{`: `}<em parentName="p">{`typeof`}</em>{` `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/media/photoshopcore/"
      }}><em parentName="a">{`photoshopCore`}</em></a></p>
    <p>{`The set of lower level APIs for directly interfacing with Photoshop UI and user`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      